import React, { Fragment } from 'react';

const MapsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            The map is a component the user interact with for geographic information.
          </h1>
        </div>
        <div className="right">
          <p>When there is information related to geographic locations, the map is a good component to use. It can be used both to get information out of it, as it can be used to input information in some very specific cases. The colours of the map and all its controllers were designed to be coherent with the product where the map is inserted.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Pin</h2>
          <p>The pin was designed to be used in cases where there is the need to input exact locations on the map. The draggable pin a flexible solution that gives the user the perfect control for address input.</p>
          <h2 className="h2 page-subtitle">Pop and Cluster</h2>
          <p>Pops, or points of presence, are used to show locations on the map. When the map is zoomed out and there are several Pops close together a Cluster-Pop is shown to represent all the Pops.</p>
          <h2 className="h2 page-subtitle">Order Lines</h2>
          <p>Three elements are part of the order lines: blue points, red points, and lines. Blue points are used on the map for virtual numbers on destination chosen by the user. And the red dots are connected by the order lines, showing the origin and destination chosen by the user.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default MapsUsage;


// WEBPACK FOOTER //
// ./src/containers/components/Map/MapsUsage.js